// extracted by mini-css-extract-plugin
export default {"errorMessage":"page_errorMessage__KpxrZ"};